import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import BuscarLancamentoControleAporteModel from "../models/lancamentoControleAporte/chamadas/buscarLancamentoControleAporteModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarLancamentoControleAporte, setModalDeletarLancamentoControleAporte } from "../redux/slices/lancamentoControleAporte/lancamentoControleAporteSlice";

export const cadastrarLancamentoControleAporte = createAsyncThunk("/LancamentoControleAporte/CadastrarLancamentoControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/LancamentoControleAporte/CadastrarLancamentoControleAporte", payload.value);
    toastSucess("Lançamento foi cadastrada com sucesso");
    dispatch(setModalCadastrarLancamentoControleAporte(false));
    dispatch(setLoading(false));

    dispatch(buscarLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarLancamentoControleAporte = createAsyncThunk("/LancamentoControleAporte/BuscarLancamentoControleAporte", async (args: BuscarLancamentoControleAporteModel) => {
  try {
    const data = await api.get("/LancamentoControleAporte/BuscarLancamentoControleAporte/", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarLancamentoControleAporte = createAsyncThunk("/LancamentoControleAporte/AtualizarLancamentoControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/LancamentoControleAporte/AtualizarLancamentoControleAporte", payload.value);
    toastSucess("Lançamento foi atualizado com sucesso");
    dispatch(setModalCadastrarLancamentoControleAporte(false));
    dispatch(setLoading(false));

    dispatch(buscarLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarStatusControleAporte = createAsyncThunk("/LancamentoControleAporte/AtualizarStatusControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/LancamentoControleAporte/AtualizarStatusControleAporte", null, {
      params: payload.value,
    });
    toastSucess("Status do lançamento foi atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarLancamentoControleAporte = createAsyncThunk("/LancamentoControleAporte/DeletarLancamentoControleAporte", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/LancamentoControleAporte/DeletarLancamentoControleAporte", { params: { idLancamentoControleAporteRecebimento: payload.value } });
    toastSucess("Lançamento foi removido com sucesso");
    dispatch(setModalDeletarLancamentoControleAporte(false));
    dispatch(setLoading(false));

    dispatch(buscarLancamentoControleAporte(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
